import React from "react";
import { Plus } from "lucide-react";
import { slab } from "./faqConstants";
import { faqEqual } from "./faqUtils";
import { useFaqStore } from "src/store/faqStore";

export const FaqEmptyCategories: React.FC = () => {
  const canManage = useFaqStore((s) => s.canManage);
  const addSection = useFaqStore((s) => s.addSection);
  const isDirty = useFaqStore(
    (s) =>
      s.form != null &&
      s.savedBaseline != null &&
      s.form.faq.length === 0 &&
      !faqEqual(s.form, s.savedBaseline),
  );

  return (
    <div className="rounded-[1.75rem] border-4 border-dashed border-[#E5E5E5]/60 bg-white/90 p-10 text-center shadow-[0_8px_0_#D0D0D0]">
      <p className="text-lg font-extrabold text-[#3C3C3C]">No categories yet</p>
      <p className="mt-2 font-semibold text-[#777777]">
        Add a category to match the mobile JSON shape: title plus Q&amp;A rows.
        {isDirty && (
          <>
            {" "}
            You removed all categories — click{" "}
            <span className="font-extrabold text-[#3C3C3C]">Save FAQ</span>{" "}
            below to clear Firestore.
          </>
        )}
      </p>
      {canManage && (
        <button
          type="button"
          onClick={() => addSection()}
          className="mt-6 inline-flex min-h-[52px] items-center justify-center gap-2 rounded-2xl border-0 px-8 text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_6px_0_#0F766E] transition-transform active:translate-y-1 active:shadow-[0_2px_0_#0F766E]"
          style={{ backgroundColor: slab.teal }}
        >
          <Plus className="h-5 w-5" aria-hidden />
          Add your first category
        </button>
      )}
    </div>
  );
};
